import "./App.css";
import Home from "./Pages/Home";
import Navbar from "./Pages/Navbar";
import ContactForm from "./Pages/ContactForm";
import { Route, Routes } from "react-router-dom";
import Project1 from "./Pages/Project1";
import Project2 from "./Pages/Project2";
import Project3 from "./Pages/Project3";
import About from "./Pages/About";
import Blog from "./Pages/Blog";
import Footer from "./Pages/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App  mx-auto font-mono">
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/home" element={<Home></Home>}></Route>
        <Route path="/contact" element={<ContactForm></ContactForm>}></Route>
        <Route path="/about" element={<About></About>}></Route>
        <Route path="/blog" element={<Blog></Blog>}></Route>
        <Route path="/project1" element={<Project1></Project1>}></Route>
        <Route path="/project2" element={<Project2></Project2>}></Route>
        <Route path="/project3" element={<Project3></Project3>}></Route>
      </Routes>
      <Footer></Footer>
      <ToastContainer />
    </div>
  );
}

export default App;
